<template>
    <div class="add-music-page">
        <app-loading 
            v-if="loading"
        />

        <app-header 
            :position="'fixed'"
            :top="'0px'"
            :background="'#2F1F4C'"
            @clickBack="clickBack"
            @clickMenu="change_menu(context, true)"
        />

        <div class="add-music-page__title">
            Музыка
        </div>

        <div class="add-music-page__musics-wrapper">
            <app-one-music 
                v-for="(item, index) in musics"
                :key="item.title"
                :index="index"
                :title="item.title"
                :status="item.status"
                :play="item.play"
                :file="item.file"
                :id="item.id"
                :selected="item.selected"
                :arr="item"
                @clickOneMusic="(data) => music_click_one_element(context, data)"
                @clickPlay="(data) => music_click_play(context, data)"
                @clickStop="music_click_stop(context)"
                @clickSelectMusic="(data) => music_click_select(context, data)"
            />
        </div>


        <transition 
            name="fade-menu" 
            appear
            mode="out-in"
        >
            <app-menu 
                v-if="menu"
                idLogoMenu="header-component__menu"
                @clickLink="change_menu(context, false)"
                @clickOutside="change_menu(context, false)"
            />
        </transition >


        <transition 
            name="fade-overlay" 
            appear
            mode="out-in"
        >
            <app-overlay 
                v-if="overlay"
            />
        </transition>
    </div>
</template>

<script>
    
    const AppLoading = () => import('@/components/loading.vue')
    const AppHeader = () => import('@/components/header.vue')
    const AppMenu = () => import('@/components/menu.vue')
    const AppOverlay = () => import('@/components/overlay.vue')
    const AppOneMusic = () => import('@/components/one-music.vue')

    import music_get from "@/views/add_music/modules/music_get";
    import change_menu from "@/views/theme/modules/change_menu";
    import music_click_one_element from "@/views/add_music/modules/music_click_one_element";
    import music_click_play from "@/views/add_music/modules/music_click_play";
    import music_click_stop from "@/views/add_music/modules/music_click_stop";
    import music_click_select from "@/views/add_music/modules/music_click_select";


    export default {
        async mounted() {
          await this.music_get(this)
        },
        data() {
            return {
                context: this,
                musics: [],
                overlay: false,
                menu: false,
                rendering: false
            }
        },
        components: {
            AppLoading,
            AppHeader,
            AppMenu,
            AppOverlay,
            AppOneMusic
        },
        methods: {
          music_get,
          change_menu,
          music_click_one_element,
          music_click_play,
          music_click_stop,
          music_click_select,
          async clickBack() {
            window.history.back()
          }
        },
        computed: {
            music() {
                return this.$store.getters['music/music']
            },
            loading() {
              return !(this.musics.length > 0 && this.rendering)
            }
        }
    }
</script>

<style lang="less">
    .add-music-page {
        background-color: #2F1F4C;
        width: 100%;
        min-height: calc(var(--vh, 1vh) * 100);
        display: flex;
        flex-direction: column;
    }

    @import '~/assets/fonts/montserrat/Montserrat-Bold.less';

    .add-music-page__title {
        font-size: 28px;
        line-height: 20px;
        color: #FFFFFF;
        font-family: 'Montserrat-Bold';
        margin-top: 76px;
        margin-left: 16px;
    }

    @import '~/assets/fonts/roboto/Roboto-Light.less';

    .add-music-page__musics-wrapper {
        display: flex;
        flex-direction: column;
        margin-top: 32px;
    }
    .add-music-page__musics-wrapper:last-child {
        border-bottom: 0.5px solid rgba( 255, 255, 255, .2);
    }
</style>